import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  openAiModelsFetch,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_CEREBRAS_BASE_URL = "https://api.cerebras.ai/v1";

const MODELS_ENDPOINT = `${DEFAULT_CEREBRAS_BASE_URL}/models`;

const cerebrasModelsFetch = openAiModelsFetch(
  "Fetch models from Cerebras",
  () => MODELS_ENDPOINT
);

export const cerebras = defineConnector({
  identifier: "cerebras",
  name: "Cerebras",
  tagLine: "AI inference on wafer-scale hardware",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.cerebras\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Cerebras Cloud](https://cloud.cerebras.ai/) and create an API key from the API keys page.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "csk-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [{ field: "name", placeholder: "llama3.1-8b" }],
          addLabel: "Add model",
          fetch: cerebrasModelsFetch,
          helperText: MODELS_HELPER_TEXT,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => MODELS_ENDPOINT,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
